module.exports = __webpack_public_path__ + "static/media/sentinels.c0bc79fb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/power-grip-dragoons/sentinels.gif
// module id = 802
// module chunks = 0